import Vue from 'vue'
import VueRouter from 'vue-router'

// Landing Pages
import Home from '../views/Home.vue'
import Instructions from '../views/Instructions.vue'
import Data from '../views/data/Index.vue'
import DataEntry from '../views/data/Entry.vue'
import DataTables from '../views/data/Tables.vue'

// Data Entry
import SimplePasture1 from '../views/data/entry/SimplePasture1.vue'
import SimplePasture2 from '../views/data/entry/SimplePasture2.vue'
import SimplePasture3 from '../views/data/entry/SimplePasture3.vue'
import SimplePasture4 from '../views/data/entry/SimplePasture4.vue'
import SeasonalPasture1 from '../views/data/entry/SeasonalPasture1.vue'
import SeasonalPasture2 from '../views/data/entry/SeasonalPasture2.vue'
// import SeasonalPasture3 from '../views/data/entry/SeasonalPasture3-single-stock.vue'
import SeasonalPasture3 from '../views/data/entry/SeasonalPasture3-multiple-stock.vue'
import OtherTools1 from '../views/data/entry/OtherTools1.vue'
import OtherTools2 from '../views/data/entry/OtherTools2.vue'
import OtherTools3 from '../views/data/entry/OtherTools3.vue'
import OtherTools4 from '../views/data/entry/OtherTools4.vue'


Vue.use(VueRouter)

const routes = [
  {
    alias: '',
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/instructions',
    name: 'Instructions',
    component: Instructions
  },
  {
    path: '/data',
    name: 'Data',
    component: Data,
    children: [
      {
        alias: '',
        path: '/data/entry',
        name: 'Data entry',
        component: DataEntry,
        children: [
          {
            path: '/data/entry/simple-pasture-1',
            name: 'How long will the paddock last?',
            component: SimplePasture1
          },
          {
            path: '/data/entry/simple-pasture-2',
            name: 'How much feed will be available at the end of the grazing period?',
            component: SimplePasture2
          },
          {
            path: '/data/entry/simple-pasture-3',
            name: 'How many head can I run in this paddock?',
            component: SimplePasture3
          },
          {
            path: '/data/entry/simple-pasture-4',
            name: 'How many hectares do I need?',
            component: SimplePasture4
          },
          {
            path: '/data/entry/seasonal-pasture-1',
            name: 'Summer feed budget',
            component: SeasonalPasture1
          },
          {
            path: '/data/entry/seasonal-pasture-2',
            name: 'Winter feed budget',
            component: SeasonalPasture2
          },
          {
            path: '/data/entry/seasonal-pasture-3',
            name: 'Rotation planner',
            component: SeasonalPasture3
          },
          {
            path: '/data/entry/other-tools-1',
            name: 'Farm paddock grazing days recorder',
            component: OtherTools1
          },
          {
            path: '/data/entry/other-tools-2',
            name: 'Calculate phosphorus required and cost',
            component: OtherTools2
          },
          {
            path: '/data/entry/other-tools-3',
            name: 'Feeding supplements at pasture',
            component: OtherTools3
          },
          {
            path: '/data/entry/other-tools-4',
            name: 'Compare nitrogen, gibberellic acid and supplement values',
            component: OtherTools4
          }
        ]
      },
      {
        path: '/data/tables',
        name: 'Data tables',
        component: DataTables
      }
    ]
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
      return {
        x: 0, y: 0
      }
    }
  }
})

export default router
